import { CustomChip } from "components";
import React from "react";

interface MaterialSpecCellProps {
    value: string;
    tooltip?: string;
    colour?: string;
}

export const MaterialSpecCell = ({ value, colour }: MaterialSpecCellProps) => {
    if (colour) {
        return <CustomChip bgColor={colour} label={value} minWidth={180} />;
    }

    return <>{value}</>;
};
